import { Component, Inject, OnInit, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { DomPortal, TemplatePortal } from '@angular/cdk/portal';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

import { NotificationConfig, NotificationService } from 'app/shared';

/**
 * Notification Component
 */
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  contentPortal: DomPortal | TemplatePortal;
  showClose: boolean = false;

  constructor(
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef,
    private notification: NotificationService,
    @Inject(MAT_SNACK_BAR_DEFAULT_OPTIONS) private defaultConfig: NotificationConfig,
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { msg: App.NotificationMessageType; notificationType: App.NotificationType },
    @Inject(MatSnackBarRef) private snackBarRef: MatSnackBarRef<NotificationComponent>,
  ) {
    this.showClose = coerceBooleanProperty(this.defaultConfig.showClose);
  }

  ngOnInit(): void {
    const data = this.data;

    if (data) {
      if (typeof data.msg === 'string') {
        this.contentPortal = this.notification.createPortal(
          data.msg,
          this.viewContainerRef,
          this.renderer
        );
      } else if (data.msg instanceof TemplateRef) {
        this.contentPortal = this.notification.createPortal(data.msg, this.viewContainerRef);
        this.contentPortal.context = {
          ...data,
          msg: undefined
        };
      } else {
        this.contentPortal = this.notification.createPortal(data.msg);
      }
    }
  }

  close(): void {
    this.snackBarRef.dismiss();
  }
}
